import _ from 'underscore';
import MapStatesView from '@/data/views/map_states';
import MapStationCountsTemplate from '@/templates/data/map-station-counts.hbs';

export default MapStatesView.extend({
  template: MapStationCountsTemplate,

  events: {
    'change input[type=checkbox]': 'toggleAccess'
  },

  getTotalMode: function() {
    var mode = 'unknown';
    var $public = this.$el.find('input[name=stations_public]');
    var $private = this.$el.find('input[name=stations_private]');
    if($public.is(':checked') && $private.is(':checked')) {
      mode = 'total';
    } else if($public.is(':checked')) {
      mode = 'public';
    } else if($private.is(':checked')) {
      mode = 'private';
    }

    return mode;
  },

  getChartData: function() {
    var totalMode = this.getTotalMode();

    var label = '';
    if(totalMode === 'total') {
      label = '# Public & Private ' + this.model.get('station_label');
    } else if(totalMode === 'public') {
      label = '# Public ' + this.model.get('station_label');
    } else if(totalMode === 'private') {
      label = '# Private ' + this.model.get('station_label');
    }

    var chartData = _.map(this.model.get('data'), function(stateData) {
      var value = stateData[totalMode] || 0;
      return [stateData.name, value];
    })
    chartData.unshift(['State', label]);

    return window.google.visualization.arrayToDataTable(chartData);
  },

  toggleAccess: function() {
    this.chart.draw(this.getChartData(), this.getChartOptions());
  },
});
